// @module C3.ShoppingExtensions.InventoryList
define('C3.ShoppingExtensions.NewsletterSignup.Automatic.View'
,	[
	'c3_shoppingextensions_newslettersignup_automatic.tpl'
	,   'C3.ShoppingExtensions.NewsletterSignup.Countries.View'
	,   'C3.ShoppingExtensions.NewsletterSignup.States.View'
    ,	'Backbone'
    ,   'Profile.Model'
    ,   'Backbone.FormView'
    ,   'Backbone.CompositeView'
    ,   'C3.ShoppingExtensions.NewsletterSignup.Model'
    ,   'Utils'
    ,   'C3.ShoppingExtensions.NewsletterSignup.MobilePreferences.View'
    ,   'AjaxRequestsKiller'
    ,   'GlobalViews.Breadcrumb.View'
	,   'js.cookie'
    ,   'C3.ShoppingExtensions.NewsletterSignup.AutomaticSuccess.View'
    ]
, function (
	c3_shoppingextensions_newslettersignup_automatic_tpl
	,   CountriesView
    ,   StatesView
	,	Backbone
	,   ProfileModel
    ,   BackboneFormView
    ,   BackboneCompositeView
    ,   NewsletterSignupModel
    ,   Utils
    ,   MobileView
    ,   AjaxRequestsKiller
	,   GlobalViewsBreadcrumbView
    ,   Cookie
    ,   AutomaticSuccessPopupView
)
{
    'use strict';

	// @class C3.ShoppingExtensions.InventoryList.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_newslettersignup_automatic_tpl

	,   attributes: {
	        id: 'newsletter-signup'
	    }		

    ,   modalClass: 'automatic-popup-modal'    

	,	title: Utils.translate('Newsletter')

	,	initialize: function (options) {
			this.options = options;
            this.application = options.application;
			this.countries = this.application.configuration.get('siteSettings.countries', []);

            /*this.userEmail = options.userEmail;
            this.userId = options.userId;*/

            //this.userInfo = options.user;
            this.newsubscriber = options.newsubscriber;

           // this.userCountry = this.userInfo.custentity_destination_country
           // this.userState = this.userInfo.custentity_customer_state

            var profile = ProfileModel.getInstance()
            ,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'

            this.profile = profile;
            this.model = options.model || new NewsletterSignupModel();


            //BackboneCompositeView.add(this);
            BackboneFormView.add(this);
		}

	,   render: function(){
            //console.log(this.profile);
            /*var userid = this.profile.get('internalid')
            var self = this;
            this.model.fetch({
                data: {
                    internalid: userid
                },
                killerId: AjaxRequestsKiller.getKillerId()
            }).done(function(result) {           
                    self.userInfo = result.user[0];
                    self._render();
            });*/
		    this._render();
        }  	

	,	events: {
		 'submit form': 'submitForm',
		 'change [data-action="selectcountry"]': 'updateStates',
        // 'click [data-action="Subscribe-All"]': 'subscribeFunctionality',
         'change [data-action="Subscribe-All"]': 'subscribeAllEmailPreferences',
         'change [data-action="individual-subscribe"]': 'subscribeIndividualPreferences',
         'change [data-action="product-interests-checked"]': 'subscribeIndividualPreferences',
         'click [data-action="set-automatic-hide-cookie"]' : 'setAutomaticHideCookie'
		}

	,	bindings: {
        '[name="firstname"]': 'firstname',
        '[name="lastname"]': 'lastname',
        '[name="phone"]': 'phone',
        '[name="email"]': 'email',
        '[name="custentity_destination_country"]': 'custentity_destination_country',
        '[name="custentity_customer_state"]': 'custentity_customer_state'
		}

	, 	childViews: {
            'Newsletter.Countries.Dropdown': function() {
                //console.log(this.countries)
                if(this.userCountry)
                this.selectedCountry =  this.userCountry;

                return new CountriesView({
                    countries: this.countries,
                    selectedCountry: this.selectedCountry,
                    manage: this.options.manage
                });
            },
            'Newsletter.States.Dropdown': function() {
                //console.log(this.loggedUserState)
                if(this.userState)
                this.selectedState =    this.userState;

                if(this.userCountry)
                this.selectedCountry =  this.userCountry;

                return new StatesView({
                    countries: this.countries,
                    selectedCountry: this.selectedCountry,
                    selectedState: this.selectedState,
                    manage: this.manage
                });
            },
            'Global.Breadcrumb': function() {
				var ieBreadcrumbs = [];

				 ieBreadcrumbs[0] = {
		                href : '/',
		                'data-hashtag' : '#',
		                'data-touchpoint': "home",
		                hasDataHashtag: true,
		                hasDataTouchpoint: true,
		                text: "Home"
		          }

	           	ieBreadcrumbs[1] = {
                     href : '/',
                     text: "Newsletter Signup Form"
                }

	        	return new GlobalViewsBreadcrumbView({
	        			 pages: ieBreadcrumbs 
	        		});
        	}
    }


    ,   submitForm: function(e) {
        e.preventDefault();

         const self = this;
         const data = (jQuery(e.target).closest('form')).serializeObject();

         console.log(data)


         const promise = this.saveForm(e);

         

         const container = self.$containerModal;
         var Layout = this.application.getComponent('Layout');            

         if (promise) {
            $('#in-modal-submit-newsletter-form').text('Processing...')
            $('#in-modal-submit-newsletter-form').attr('disabled','disabled');
                promise
                    .fail(function(jqXhr) {
                        console.log(jqXhr)
                        $('.newsletter-alert-placeholder').html("<div class='global-views-message global-views-message-success alert' role='alert'><div>Sorry, subscription cannot be updated. Try again later.</div></div>");
                    })
                    .done(function(res) {
                        console.log(res)
                        if(res.code == 'OK')
                        {
                            if(Utils.isPhoneDevice())
                            {
                                var mobile = new MobileView({
                                    application : self.application,
                                    model : new NewsletterSignupModel(),
                                    userId : res.user.internalid,
                                    //productInterests : self.userInfo.productinterests,
                                    fromautomatic: true
                                })

                                if (mobile)
                                Layout.showContent(mobile, {showInModal: true});
                            }
                            else
                            {
                                var automaticSuccess = new AutomaticSuccessPopupView({
                                    application : self.application
                                })

                                if (automaticSuccess)
                                Layout.showContent(automaticSuccess, {showInModal: true});
                                
                                Cookie.set('hideautomaticpopupcookie', true, { expires: 1 });
                            }
                        }
                        
                    })
            }
    }

    ,  setAutomaticHideCookie: function(e)
    {
        Cookie.set('hideautomaticpopupcookie', true, { expires: 1 });
    }

    ,   updateStates: function(e){
            var statesView = this.getChildViewInstance('Newsletter.States.Dropdown');
            var selectedCountry= $(e.currentTarget).val();

            var self = this;
             
            var find_country = _.findWhere(self.countries, {
                    name: selectedCountry
                });
            
            if(find_country)
            {
                //var available_states = find_country.states;
                statesView.options.selectedCountry = find_country.code;
                this.selectedCountry = find_country.code;
                statesView.render();

            }
            else{
                statesView.options.selectedCountry = '';
                this.selectedCountry = '';
                statesView.render();
            }
            //console.log(statesView)
        }

    ,  subscribeIndividualPreferences: function(e){
        var currentTarget = $(e.currentTarget)
        ,   currentTargetProp = currentTarget.prop('checked')
        //console.log(currentTargetProp)
        if(currentTargetProp == true){
           currentTarget.prop('checked',true);
           currentTarget.attr('value', 'T'); 
        }
        else{
            currentTarget.prop('checked',false);
           currentTarget.attr('value', ''); 
        }
        
    }    

    ,  subscribeAllEmailPreferences: function(e){
        e.preventDefault();
        var currentTarget = $(e.currentTarget)
        ,   currentTargetProp = currentTarget.prop('checked')

        if(currentTargetProp == true)
        {
            /*$('[name="custentity_mc_opt_in"]').prop('checked', true);
            $('[name="custentity_mc_opt_in"]').attr('value', 'T');
            $('[name="weeklydeals"]').prop('checked', true);
            $('[name="weeklydeals"]').attr('value', 'T');
            $('[name="makeoffer"]').prop('checked', true);
            $('[name="makeoffer"]').attr('value', 'T');
            $('[name="newarrivals"]').prop('checked', true);
            $('[name="newarrivals"]').attr('value', 'T');
            $('[name="recommended"]').prop('checked', true);
            $('[name="recommended"]').attr('value', 'T');*/

            $(".email-preferences-body input[type=checkbox]").prop('checked',true);
            $(".email-preferences-body input[type=checkbox]").attr('value', 'T');
        }
        else if(currentTargetProp == false)
        {
            /*$('[name="custentity_mc_opt_in"]').prop('checked', false);
            $('[name="custentity_mc_opt_in"]').attr('value', '');
            $('[name="weeklydeals"]').prop('checked', false);
            $('[name="weeklydeals"]').attr('value', '');
            $('[name="makeoffer"]').prop('checked', false);
            $('[name="makeoffer"]').attr('value', '');
            $('[name="newarrivals"]').prop('checked', false);
            $('[name="newarrivals"]').attr('value', '');
            $('[name="recommended"]').prop('checked', false);
            $('[name="recommended"]').attr('value', '');*/

            $(".email-preferences-body input[type=checkbox]").prop('checked',false);
            $(".email-preferences-body input[type=checkbox]").attr('value', '');
        }
    }    


		//@method getContext @return C3.ShoppingExtensions.InventoryList.View.Context
	,	getContext: function getContext()
		{

            /*var emailPreferencesArray = this.userInfo.emailpreferences
            //,   splitEmailPreferencesArray = []

            if(emailPreferencesArray)
            var splitEmailPreferencesArray = emailPreferencesArray.split(',')

            var weekly_deals_enabled = false
            , make_an_offer_enabled = false
            , new_arrivals_enabled = false
            , recommended_for_you_enabled = false
            , newSubscriber = this.newsubscriber

            //console.log(splitEmailPreferencesArray)

            if(emailPreferencesArray){
                _.each(splitEmailPreferencesArray,function(line){
                    if(line == '1'){
                        weekly_deals_enabled = true;
                    }
                    if(line == '101'){
                        make_an_offer_enabled = true;
                    }
                    if(line == '102'){
                        new_arrivals_enabled = true;
                    }
                    if(line == '103'){
                        recommended_for_you_enabled = true;
                    }
                });
            }


            var productInterestsArray = this.userInfo.productinterests
            ,   arthroscopy_enabled = false
            ,   laproscopy_enabled = false
            ,   urology_enabled = false
            ,   gyn_enabled = false
            ,   ent_enabled = false
            ,   orthopedic_enabled = false
            ,   neurology_enabled = false
            ,   visualization_enabled = false
            ,   flexible_endoscopy_enabled = false
            ,   patient_care_enabled = false
            ,   imaging_enabled = false
            ,   surgical_power_enabled = false
            ,   sports_medicine_enabled = false

            if(productInterestsArray)
            var splitProductInterestsArray = productInterestsArray.split(',')

            //console.log(splitProductInterestsArray)

            if(productInterestsArray){
                 _.each(splitProductInterestsArray,function(pi){
                    if(pi == '1'){
                        arthroscopy_enabled = true;
                    }
                    if(pi == '2'){
                        laproscopy_enabled = true;
                    }
                    if(pi == '3'){
                        urology_enabled = true;
                    }
                    if(pi == '5'){
                        gyn_enabled = true;
                    }
                    if(pi == '6'){
                        ent_enabled = true;
                    }
                    if(pi == '7'){
                        orthopedic_enabled = true;
                    }
                    if(pi == '9'){
                        neurology_enabled = true;
                    }
                    if(pi == '12'){
                        visualization_enabled = true;
                    }
                    if(pi == '14'){
                        flexible_endoscopy_enabled = true;
                    }
                    if(pi == '16'){
                        patient_care_enabled = true;
                    }
                    if(pi == '18'){
                        imaging_enabled = true;
                    }
                    if(pi == '33'){
                        surgical_power_enabled = true;
                    }
                    if(pi == '34'){
                        sports_medicine_enabled = true;
                    }
                });
            }

            console.log(this.userInfo)*/
			
			return {
                isPhoneDevice : Utils.isPhoneDevice()
				/*isPerson : this.userInfo.isperson === "T" ? true : false,
				userEmail : this.userInfo.email,
                userId : this.userInfo.internalid,
                userCompany : this.userInfo.company,
                userFname : this.userInfo.firstname,
                userLname : this.userInfo.lastname,
                userphone : this.userInfo.phone,
                subscribeAll : this.userInfo.optin == 'T' ? true : false,
                isPhoneDevice : Utils.isPhoneDevice(),
                weeklyDeals : weekly_deals_enabled,
                makeAnOffer : make_an_offer_enabled,
                newArrivals : new_arrivals_enabled,
                recommendedForYou : recommended_for_you_enabled,
                newSubscriber : newSubscriber,
                arthroscopy_enabled : arthroscopy_enabled,
                laproscopy_enabled : laproscopy_enabled,
                urology_enabled : urology_enabled,
                gyn_enabled : gyn_enabled,
                ent_enabled : ent_enabled,
                orthopedic_enabled : orthopedic_enabled,
                neurology_enabled : neurology_enabled,
                visualization_enabled : visualization_enabled,
                flexible_endoscopy_enabled : flexible_endoscopy_enabled,
                patient_care_enabled : patient_care_enabled,
                imaging_enabled : imaging_enabled,
                surgical_power_enabled : surgical_power_enabled,
                sports_medicine_enabled : sports_medicine_enabled*/
			};
		}
	});
});
